/**
 * 웹 3.0 상세가 보여주는 양 — 맛보기까지만.
 * @description 웹은 보기 전용이고 둘러보기도 앱에서 한다. 스레드 · 작품은 몇 개만 보이고 그 아래 앱으로
 *   가는 버튼 하나를 둔다. 더 받아 오는 쪽 넘기기 · 목록 화면 · 글 상세 화면은 웹에 없다. 참여자는 상세
 *   응답의 얼굴과 수만 쓴다(`/participants` 는 부르지 않는다).
 */
export const COLLAB_V3_TEASER = {
  /** 스레드 — 고정 글을 먼저 해서 모두 3개까지 */
  threadItems: 3,
  /** 작품 — 고른 작품이 있으면 그것, 없으면 최신 작품에서 4개까지 */
  works: 4,
} as const;
